import { Col, Row, Space } from 'antd'
import { htmlToRed, removeTag } from '../../../../tools/util'
import { Props } from './hooks'
import styles from './styles.module.scss'
import { ClockCircleOutlined, UserOutlined } from '@ant-design/icons'
import moment from 'moment'

const NewsCard = (props: Props) => {
  const { listItem, imgBaseUrl, searchParam, onDetail } = props

  return (
    <div
      className={styles['card-container']}
      onClick={() => {
        onDetail?.(listItem)
      }}
    >
      <div className={styles['inner-container']}>
        <Row>
          <Col flex={'234px'}>
            <img
              className={styles['news-cover']}
              src={listItem?.img ? imgBaseUrl + listItem?.img : undefined}
              alt="公告封面"
            />
          </Col>
          <Col flex={1} className={styles['right-col']}>
            <div>
              <div className={styles['title-container']}>
                <div className={styles['title']}>
                  {searchParam?.announcementTitle ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: htmlToRed(
                          listItem.title,
                          searchParam?.announcementTitle,
                        ),
                      }}
                    ></span>
                  ) : (
                    listItem.title
                  )}
                </div>
              </div>
              <div className={styles['content']}>
                {removeTag(listItem?.content)}
              </div>
              <div className={styles['news-info']}>
                <Space align="center" size={'large'}>
                  <div className={styles['time']}>
                    <ClockCircleOutlined style={{ marginRight: '8px' }} />
                    <span className={styles['info-font']}>
                      {listItem.createTime
                        ? moment(new Date(listItem.createTime)).format(
                            'YYYY-MM-DD HH:mm:ss',
                          )
                        : ''}
                    </span>
                  </div>
                  <div className={styles['time']}>
                    <UserOutlined style={{ marginRight: '8px' }} />
                    <span className={styles['info-font']}>
                      {listItem.createMan || '-'}
                    </span>
                  </div>
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}
export default NewsCard
import { Col, Row, Space } from 'antd'
import { htmlToRed, removeTag } from '../../../../tools/util'
import { Props } from './hooks'
import styles from './styles.module.scss'
import { ClockCircleOutlined, UserOutlined } from '@ant-design/icons'
import moment from 'moment'

const NewsCard = (props: Props) => {
  const { listItem, imgBaseUrl, searchParam, onDetail } = props

  return (
    <div
      className={styles['card-container']}
      onClick={() => {
        onDetail?.(listItem)
      }}
    >
      <div className={styles['inner-container']}>
        <Row>
          <Col flex={'234px'}>
            <img
              className={styles['news-cover']}
              src={listItem?.img ? imgBaseUrl + listItem?.img : undefined}
              alt="公告封面"
            />
          </Col>
          <Col flex={1} className={styles['right-col']}>
            <div>
              <div className={styles['title-container']}>
                <div className={styles['title']}>
                  {searchParam?.announcementTitle ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: htmlToRed(
                          listItem.title,
                          searchParam?.announcementTitle,
                        ),
                      }}
                    ></span>
                  ) : (
                    listItem.title
                  )}
                </div>
              </div>
              <div className={styles['content']}>
                {removeTag(listItem?.content)}
              </div>
              <div className={styles['news-info']}>
                <Space align="center" size={'large'}>
                  <div className={styles['time']}>
                    <ClockCircleOutlined style={{ marginRight: '8px' }} />
                    <span className={styles['info-font']}>
                      {listItem.createTime
                        ? moment(new Date(listItem.createTime)).format(
                            'YYYY-MM-DD HH:mm:ss',
                          )
                        : ''}
                    </span>
                  </div>
                  <div className={styles['time']}>
                    <UserOutlined style={{ marginRight: '8px' }} />
                    <span className={styles['info-font']}>
                      {listItem.createMan || '-'}
                    </span>
                  </div>
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}
export default NewsCard
